import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {RotateObjectService} from "../../services/rotateService/rotate-object.service";
import {fromEvent, iif, interval, of, Subject} from "rxjs";
import {debounceTime, mergeMap, throttle} from "rxjs/operators";
import {EventHandler} from "smooth-scrollbar/utils";
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";
import {Item} from "../../models/Item";
import {CesiumAdapterService} from "../../services/cesiumAdapter21/cesium-adapter.service";
import {AbstractObserver} from "../../classes/AbstractObserver/AbstractObserver";
import {isViewMode, isViewModeByShareLink} from '@src/configs/view_only';

@Component({
  selector: 'app-rotate-handler',
  templateUrl: './rotate-handler.component.html',
  styleUrls: ['./rotate-handler.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RotateHandlerComponent extends AbstractObserver implements OnInit {

  @ViewChild('handler', {static: true}) handler;
  @ViewChild('handler_line', {static: true}) handler_line;
  @ViewChild('handler_center', {static: true}) handler_center;


  private isDragging = false;
  public isVisible = false;
  public isAllowed = false;

  constructor(private rotate: RotateObjectService, private cd: ChangeDetectorRef, private ui: UiAdapterService, private adapter: CesiumAdapterService) { super()}

  ngOnInit() {
    this.subscribeToObservable(this.rotate.centerUpdated$, ((wc:{center, offset, rotate})=>{
        this.enableHandler(wc);
    }));
    this.initListeners();
  }

  canShow() {
    return this.isVisible && this.isAllowed && !isViewMode && !isViewModeByShareLink;
  }

  enableDragging(e){
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    this.isDragging = true;
    this.adapter.hideHoverText();
    this.rotate.rotateStart = true;
    // @ts-ignore
    document.querySelector('#es-cesium-container').style.cursor = 'grabbing';
  }

  private initListeners(){
    fromEvent(window, 'pointermove').pipe(throttle((event)=> interval(50), {trailing: true})).pipe(mergeMap((event ) => {
      return iif(()=> this.isDragging , of(event), of(false))
    })).subscribe((event)=>{
      if (typeof event != 'boolean'){
        let additionalRotateOffset = this.rotate.additionalRotate/(180/Math.PI);
        // @ts-ignore
        let angle = this.rotate.getRotationFromMousePosition({x: event.pageX, y: event.pageY});
        var handlePosition = this.rotate.getHandlePositionFromAngle(angle);
        let lineResult = this.adapter.getLineParamsByTwoPoints(this.rotate.centerPos, handlePosition);
        angle+=additionalRotateOffset;
        this.setHandlersPosition(handlePosition, lineResult);
        this.handler.nativeElement.style.transform = 'translate(-50%, -50%) rotate(' + (angle-additionalRotateOffset) + 'rad)';
      //
        this.rotate.objectRotated = 180/Math.PI * angle;
      }
    });

    fromEvent(window, 'pointerup').pipe(mergeMap((event ) => {
      return iif(()=> this.isVisible , of(event), of(false))
    })).subscribe((event)=>{
      if (typeof event != 'boolean'){
        // this.isVisible = false;
        // @ts-ignore
        // document.querySelector('#es-cesium-container').style.cursor = 'auto';
        if (this.isDragging){
          this.rotate.endDragging();
          let container:HTMLElement = document.querySelector('#es-cesium-container');
          container.style.cursor = 'auto';
        }
        this.isDragging = false;
        this.cd.detectChanges();
      }
    });

    fromEvent(window, 'pointerdown').subscribe(()=>{
      if (this.isVisible){
        this.isDragging = false;
        this.cd.detectChanges();
      }
    });

    this.ui.onHideDetailsSidebarUpdated$.subscribe(v => {
      if (v) {
        this.isVisible = false;
        this.rotate.clearRotateEndCb();
        this.cd.detectChanges();
      }
    });

    this.ui.onHideDetailsSidebarUpdated$.subscribe(v => {
      if (v) {
        this.isAllowed = false;
        this.isVisible = false;
        this.rotate.clearRotateEndCb();
        this.cd.detectChanges();
      } else {
        this.isAllowed = true;
      }
    });

    this.rotate.hideRotateHandler$.subscribe(()=>{
      this.isVisible = false;
      this.rotate.clearRotateEndCb();
      this.cd.detectChanges();
    });


    this.adapter.cameraEventMoveStart.subscribe(()=>{
      this.handler.nativeElement.classList.remove('active');
      this.handler_line.nativeElement.classList.remove('active');
      this.handler_center.nativeElement.classList.remove('active');
    });

    this.adapter.cameraEventMoveEnd.subscribe(()=>{
      if (this.canShow()){
        this.handler.nativeElement.classList.add('active');
        this.handler_line.nativeElement.classList.add('active');
        this.handler_center.nativeElement.classList.add('active');
      }
    });
  }

  enableHandler(wc:{center, offset, rotate}){
    this.updateHandlerPosition(wc);
    if (!this.isVisible){
      this.isVisible = true;
    }
    this.cd.detectChanges();
  }

  private updateHandlerPosition(wc:{center, offset, rotate}){
    let resultPos =  this.rotate.getHandlePositionFromAngle(wc.rotate/(180/Math.PI));
    let lineResult = this.adapter.getLineParamsByTwoPoints(wc.center, resultPos);
    this.handler_center.nativeElement.style.left = wc.center.x+'px';
    this.handler_center.nativeElement.style.top = wc.center.y+'px';

    this.setHandlersPosition(resultPos, lineResult);
    this.handler.nativeElement.style.transform = 'translate(-50%, -50%) rotate(' + wc.rotate/(180/Math.PI) + 'rad)';

    // this.cd.detectChanges();
  }

  private setHandlersPosition(resultPos, lineResult){
    this.handler.nativeElement.style.left = resultPos.x + 'px';
    this.handler.nativeElement.style.top = resultPos.y + 'px';

    this.handler_line.nativeElement.style.width = lineResult.length+'px';
    this.handler_line.nativeElement.style.transform = 'rotate(' + lineResult.rotate + 'deg) translateY(-50%)';
    this.handler_line.nativeElement.style.left = resultPos.x + 'px';
    this.handler_line.nativeElement.style.top = resultPos.y + 'px';
  }
}
